import React from "react";
import { TopButs } from "./TopButs";
import { FormBox } from "./FormBox";
import { TableBox } from "./TableBox";
import { FixedBottom } from "./FixedBottoms";
import { MaterialDialog } from "./MaterialDialog";

export default (props) => {
    const { mode } = props;
    return (
        <div className="yh-detail-box">
            {mode !== "add" && <TopButs {...props} />}
            <FormBox {...props} />
            <TableBox {...props} />
            <FixedBottom {...props} />
            <MaterialDialog {...props} />
        </div>
    )
}